<template>
  <v-card outlined>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" v-if="item.label" class="accent--text caption">
          {{ item.label }}
        </v-col>
        <v-col cols="12">
          {{ item.name }}
          <v-tooltip top v-if="item.description">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                color="lighttext"
                small
                class=" ml-2"
              >
                help
              </v-icon>
            </template>
            <div class="tooltip-limit-width">
              {{ item.description }}
            </div>
          </v-tooltip>
        </v-col>
        <v-col cols="auto" class="text-h6">
          <template v-if="item.totalResponses > 0">
            {{ item.score.value | one_decimal }}
          </template>
          <v-icon v-else color="lighttext">remove</v-icon>
        </v-col>
        <v-col
          cols="auto"
          :class="color(item.score) + '--text my-auto'"
          v-if="item.totalResponses > 0 && !hideDifference"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-icon :color="color(item.score)">
                  {{ icon(item.score) }}
                </v-icon>
                {{ item.score.difference | one_decimal }}
              </div>
            </template>
            <div class="tooltip-limit-width">
              Company Average: {{ item.score.compare | one_decimal }}
            </div>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text class="background py-1">
      <v-icon x-small color="secondarytext" class="mr-1">
        directions_bike
      </v-icon>
      {{ item.totalResponses }} responses by
      {{ item.totalUserResponses }} members
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "PulseHeatmapItemCard",
  components: {},
  props: {
    item: { type: Object },
    hideDifference: { type: Boolean, default: false }
  },
  data: () => ({}),
  watch: {},
  computed: {
    icon() {
      return score => {
        if (score.difference == 0) {
          return "remove";
        }
        return score.difference > 0 ? "arrow_drop_up" : "arrow_drop_down";
      };
    },
    color() {
      return score => {
        if (score.difference == 0) {
          return "lighttext";
        }
        return score.difference > 0 ? "success" : "error";
      };
    }
  },
  methods: {}
};
</script>
